<template>
  <img
    v-if="image"
    :class="ready ? 'loaded' : 'loading'"
    :srcset="ready ? crossOriginSRCSET(image.srcset) : null"
    :sizes="sizes || '100vw'"
    :alt="image.alt || ''"
    @load="onLoad"
  />
</template>

<script setup>
import { crossOriginSRCSET } from '@/utils'
import { useImageStore } from './ImageStore'

const props = defineProps(['context', 'filename', 'id', 'sizes'])

const images = computed(() => props.context?.images ?? [])
const method = computed(() => props.filename ? 'filename' : props.id ? 'id' : null)
const identity = computed(() => props[method.value])
const image = computed(() => images.value.find(i => i[method.value] === identity.value) ?? null)

const store = useImageStore()
const ticket = store.ticket()
const ready = computed(() => store.loadedImages.includes(image.value?.url) || ticket <= store.currentInQueue)
const loaded = ref(false)

const onLoad = () => {
  if (loaded.value) return
  loaded.value = true
  store.loaded(image.value?.url)
  store.nextInQueue()
}

setTimeout(onLoad, 500)
</script>

<style scoped>
img {
  transition: opacity 400ms ease;
}
img.loading { opacity: 0; }
img.loaded  { opacity: 1; }
</style>
